import { atom } from 'jotai'

/**
 * Drag中の位置にドロワーがあるか
 */
export const draggingOnTheDrawerAtom = atom<boolean>(false)

draggingOnTheDrawerAtom.debugLabel = 'draggingOnTheDrawerAtom'
